import { type Editor, EditorContent } from "@tiptap/react";
import { type ReactNode } from "react";

interface EditorContentWrapperProps {
  children?: ReactNode;
  editor: Editor | null;
  id: string;
  tabIndex?: number;
}

export const EditorContentWrapper = (props: EditorContentWrapperProps) => {
  const { editor, children, id, tabIndex } = props;

  return (
    <div
      tabIndex={tabIndex}
      onFocus={() =>
        editor?.chain().focus(undefined, { scrollIntoView: false }).run()
      }
    >
      <EditorContent editor={editor} id={id} />
      {children}
    </div>
  );
};
